# Data Table

A responsive table for structured data that adapts to narrow chat widths.

## Install

```bash
npx aiapp-ui add data-table
```

## Usage

```tsx
import { DataTable } from "@/components/aiapp-ui/data-table";

<DataTable
  columns={[
    { id: "name", label: "Repository", sortable: true },
    { id: "stars", label: "Stars", sortable: true },
    { id: "license", label: "License" },
  ]}
  rows={[
    { id: "1", cells: { name: "next-auth", stars: "19,420", license: "MIT" } },
    { id: "2", cells: { name: "passport", stars: "847", license: "MIT" } },
    { id: "3", cells: { name: "clerk-sdk", stars: "1,580", license: "MIT" } },
  ]}
/>;
```

**Role**: Information. For displaying structured data without requiring user input. See [Design Guidelines](/docs/design-guidelines) for how component roles work.

## Props

| Prop          | Type                      | Description                                    |
| ------------- | ------------------------- | ---------------------------------------------- |
| `columns`     | `Column[]`                | Column definitions with labels and sort config |
| `rows`        | `Row[]`                   | Row data keyed by column ID                    |
| `title`       | `string?`                 | Optional table title                           |
| `description` | `string?`                 | Optional description                           |
| `sortable`    | `boolean?`                | Enable column sorting                          |
| `onRowClick`  | `(rowId: string) => void` | Called when a row is clicked                   |

## Responsive behavior

On narrow viewports, the table switches to an expandable card layout where each row becomes a card. Columns are listed vertically inside the card.

## Accessibility

- Sortable columns use `aria-sort` attributes
- Row actions are keyboard-navigable
- Table has proper `role` and labeling
